import { render, staticRenderFns } from "./RegisterSubscriptionPage.vue?vue&type=template&id=dffbd478&scoped=true&"
import script from "./RegisterSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./RegisterSubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSubscriptionPage.vue?vue&type=style&index=0&id=dffbd478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffbd478",
  null
  
)

export default component.exports